var map = {
	"./home": 5713,
	"./home.js": 5713,
	"./slides/4 bilhoes de infinitos 2.jpg": 1296,
	"./slides/Abdução 3.jpg": 4972,
	"./slides/Anderson 1.jpg": 6531,
	"./slides/Morro do Cemitério 3.jpg": 2989,
	"./slides/Serrão 2.jpg": 4998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9145;